import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column flex-root"
}
const _hoisted_2 = { class: "login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-signin-on" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto",
  style: {"background-color":"rgb(242, 201, 138)"}
}, null, -1)
const _hoisted_4 = { class: "login-aside d-flex flex-column flex-row-auto" }
const _hoisted_5 = { class: "d-flex flex-column-fluid flex-center" }
const _hoisted_6 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_7 = { class: "d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1" }
const _hoisted_8 = { class: "d-flex flex-center flex-column flex-lg-row-fluid" }
const _hoisted_9 = { class: "d-flex flex-center flex-wrap px-5" }
const _hoisted_10 = { class: "d-flex fw-semibold text-primary fs-base" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Hakkında")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("İletişim")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Gizlilik")
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2\" style=\"background:rebeccapurple;\"><div class=\"d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100\"><a href=\"#/\" class=\"mb-0 mb-lg-12\"><img alt=\"Logo\" src=\"/media/logos/logo-sm.png?f\" class=\"h-100px h-lg-100px\"></a><img class=\"d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20\" src=\"/metronic8/vue/demo2//media/misc/auth-screens.png\" alt=\"\"><h1 class=\"d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7\"> Hızlı, Efektif ve Verimli </h1><div class=\"d-none d-lg-block text-white fs-base text-center\"> Tüm yemek servisleri tek bir panelde birleşti, <a href=\"#\" class=\"opacity-75-hover text-warning fw-bold me-1\">yemek sepeti</a> , <a href=\"#\" class=\"opacity-75-hover text-warning fw-bold me-1\">trendyol yemek</a> , <a href=\"#\" class=\"opacity-75-hover text-warning fw-bold me-1\">getir yemek</a> , <br> ve <a href=\"#\" class=\"opacity-75-hover text-warning fw-bold me-1\">PaketServisi</a> ürün yorum ve opsiyonlarını <br>artık tek bir yerden tek tuşla kapatıp açabileceksiniz. </div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/hakkinda",
              class: "px-5"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/destek",
              class: "px-5"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/gizlilik",
              class: "px-5"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_14
    ])
  ], 64))
}